
/* styles */
require("!!vue-style-loader!css-loader?{\"minimize\":false,\"sourceMap\":false}!../../../../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-4fa342c4\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader!sass-resources-loader?{\"resources\":[\"/data/wwwroot/shop.yaoking.cn/build/espier-retail-manage/app/src/style/theme.scss\",\"/data/wwwroot/shop.yaoking.cn/build/espier-retail-manage/app/src/style/_mixin.scss\"]}!../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Footer.vue")

var Component = require("!../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Footer.vue"),
  /* template */
  require("!!../../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-4fa342c4\"}!../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Footer.vue"),
  /* scopeId */
  "data-v-4fa342c4",
  /* cssModules */
  null
)
Component.options.__file = "/data/wwwroot/shop.yaoking.cn/build/espier-retail-manage/app/src/view/pc/homePage/components/common/Footer.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Footer.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4fa342c4", Component.options)
  } else {
    hotAPI.reload("data-v-4fa342c4", Component.options)
  }
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/view/pc/homePage/components/common/Footer.vue
// module id = 2290
// module chunks = 0